import React from "react";

import { Lazy } from "../Lazy";
import * as styles from "./Linkify.scss";

const LinkifyImpl = Lazy(async () => (await import("react-linkify")).default);

export interface ILinkifyProps {
    text: string;
}

export class Linkify extends React.Component<ILinkifyProps> {
    public render() {
        return (
            <span className={styles.linkify}>
                <LinkifyImpl
                    componentDecorator={this.linkifyComponentDecorator}
                >
                    {this.props.text}
                </LinkifyImpl>
            </span>
        );
    }

    private linkifyComponentDecorator = (
        href: string,
        text: string,
        key: number,
    ) => {
        return (
            <a
                href={href}
                key={key}
                target="_blank"
                onClick={this.onClick}
                rel="noreferrer"
            >
                {text}
            </a>
        );
    };

    private onClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.stopPropagation();
    };
}
